import { jsx, Fragment } from "react/jsx-runtime";
import styled from "styled-components";
import { Item } from "./Item7.js";
const OPACITY_VALUES = ["1", "0.7", " 0.4"];
function SkeletonList({
  amount = 3,
  itemRender
}) {
  const amountOfItems = amount > 3 ? 3 : amount;
  return /* @__PURE__ */ jsx(Fragment, {
    children: Array(amountOfItems).fill(null).map((_, index) => /* @__PURE__ */ jsx(Opacity, {
      value: OPACITY_VALUES[index],
      children: itemRender
    }, `opacity-${OPACITY_VALUES[index]}`))
  });
}
const Opacity = styled.div.withConfig({
  displayName: "Opacity",
  componentId: "sc-1pwzqts-0"
})(["opacity:", ";"], ({
  value = 1
}) => value);
SkeletonList.Item = Item;
export {
  SkeletonList
};
//# sourceMappingURL=SkeletonList.js.map
